import { Nav } from 'react-bootstrap';
import { NavItemWrapper } from '../styles';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    section: string,
    tabText: string,
    centerId: number,
    centerAlias: string,
}

const NavRecipientCenter = (props: IProps) => {
    const { section, tabText, centerId, centerAlias } = props;
    const hrefPrefix = `/center/${centerId}/billing`;
    const tabWidth = '230';

    return (
        <div style={{ padding: 20, backgroundColor: 'white' }}>
            <Nav bsStyle='pills' className='acc-pills'>
                <NavItemWrapper active={section == 'PAY-THROUGH-NKR'} href={hrefPrefix + '/pay-through-nkr'} tabWidth={tabWidth}>
                    Pay Centers Through NKR
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'BILLED-TO-CENTER'} href={hrefPrefix + '/billed-to-center'} tabWidth={tabWidth}>
                    Billed to {centerAlias}
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'PAYMENT-SUBMITTED-BY'} href={hrefPrefix + '/payment-submitted-by'} tabWidth={tabWidth}>
                    Billing Requests
                </NavItemWrapper>

                <li role='presentation'><span>|</span></li>

                <NavItemWrapper active={section == 'SEARCH'} href={hrefPrefix + '/ap-search'} tabWidth={tabWidth}>
                    Search
                </NavItemWrapper>

                {section.toUpperCase() == 'PAY' && (
                    <>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper active={section == 'PAY'} tabWidth={tabWidth}>
                            {ReactHtmlParser(tabText)}
                        </NavItemWrapper>
                    </>
                )}

                {section.toUpperCase() == 'PAYMENT-VIEW-EDIT' && (
                    <>
                        <li role='presentation'><span>|</span></li>
                        <NavItemWrapper active={section == 'PAYMENT-VIEW-EDIT'} tabWidth={tabWidth}>
                            {ReactHtmlParser(tabText)}
                        </NavItemWrapper>
                    </>
                )}
            </Nav>
        </div>
    );
}

export default NavRecipientCenter;